// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The tooltip manager token.
 */
export const ITooltipManager = new Token('@jupyterlab/tooltip:ITooltipManager');
//# sourceMappingURL=tokens.js.map